<div class="px-5">
  <ng-container *ngIf="dataSource?.filteredData.length > 0">
    <div>
        <header class="row">
            <div class="col-12 d-flex justify-content-between">
              <h2>Compras asignadas con pago pendiente</h2>
            </div>
          </header>
    </div>

    <mat-table #table [dataSource]="dataSource" matSort class="mobile-table" (matSortChange)="onSortChange($event)">
          <!-- Responsive Table -->
          <ng-container [matColumnDef]="column.display" *ngFor="let column of displayedColumns">
              <mat-header-cell *matHeaderCellDef mat-sort-header="{{column.property}}" [disabled]="column.display=='Acciones'"> {{column.display}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="row p-0 m-0 ">
                  <span class="col-12 mobile-label"> {{column.display}}:</span>
                  <span class="col-12" style="border-radius: 5px;"
                      *ngIf="column.display != 'Acciones' && column.display != 'Hipervínculo al caso'; else actionsTemplate">
                      {{ element[column.property] 
                      }}
                  </span>                 
                  <ng-template #actionsTemplate>
                    <ng-container *ngIf="column.property == 'caseId' && column.display == 'Hipervínculo al caso' && element[column.property]!= null">
                      <a href="/ecommerce/mis-casos/detail/{{element.caseId}}">
                        Ir al caso
                      </a>
                    </ng-container>
                    <ng-container *ngIf="column.property == '' && column.display == 'Acciones'">
                      <div class="my-auto">
                        <button (click)="goToCheckout(element['orderId'])" class="button secondary-button text-white lh-1">
                          Completar Checkout
                        </button>
                      </div>
                    </ng-container>
                  </ng-template>
              </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columnsToDisplay;"></mat-row>
      </mat-table>
      <mat-paginator #paginator [length]="totalRows"
              [showFirstLastButtons]="true"
              [pageSize]="10"
              [pageSizeOptions]="[5, 10, 25, 100]"
              (page)="getAll(true)">
      </mat-paginator>
  </ng-container>
</div>
